import { Code, IconContacts } from '~/design-system';
import { getApi } from '~/platform/data/apiSingleton';
import type { ModuleDefinition } from '~/platform/registry/types';

export const contactsModule: ModuleDefinition = {
  id: 'contacts',
  i18nNamespace: 'contacts',
  requires: { subject: 'contact', action: 'read' },

  nav: {
    labelKey: 'contacts:nav',
    icon: IconContacts,
    to: 'contacts',
    group: 'people',
    order: 10,
  },

  routes: [{ path: 'contacts', component: () => import('./ContactsPage') }],

  commands: [
    {
      id: 'contacts.new',
      labelKey: 'contacts:newContact',
      groupKey: 'contacts:title',
      requires: { subject: 'contact', action: 'create' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/contacts?new=1`),
    },
  ],

  search: async (query, { businessId }) => {
    const parties = await getApi().listParties(businessId, { search: query, limit: 6 });
    return parties.slice(0, 6).map((party) => ({
      id: party.id,
      moduleId: 'contacts' as const,
      code: party.code,
      title: party.name,
      subtitle: party.roles.join(' · '),
      handlingClass: party.roles.includes('supplier') ? 'chilled' : 'neutral',
      stamp: party.taxId ? <Code>{party.taxId}</Code> : undefined,
      to: `/b/${party.businessId}/contacts?party=${party.id}`,
    }));
  },
};
